import './GenerateQuestionDialogHeader.scss';

import type { ComponentProps, ReactElement } from 'react';
import * as React from 'react';

import { translate } from '@showbie-socrative/socrative-utils/lib/translator/client';

import { Badge } from '~shared/components/Badge';
import { IconButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/large';
import { LearnMoreIcon } from '~teacher/components/QuizEditor/GenerateQuestionDialog/LearnMoreIcon';

interface GenerateQuestionDialogContentProps {
  children: React.ReactNode;
  header: ReactElement<ComponentProps<typeof GenerateQuestionDialogHeader>>;
  footer?: ReactElement<ComponentProps<typeof GenerateQuestionsDialogFooter>>;
}

interface GenerateQuestionsDialogFooterProps {
  children: React.ReactNode;
}
export function GenerateQuestionsDialogFooter({
  children,
}: GenerateQuestionsDialogFooterProps) {
  return (
    <div
      style={{
        boxShadow: '0px 1px 0px 0px #E7EDF0 inset',
      }}
      className="flex sticky bottom-0 bg-white justify-end items-center gap-3 p-5"
    >
      {children}
    </div>
  );
}

export interface GenerateQuestionDialogHeaderProps {
  children: React.ReactNode;
  onBack?: () => void;
}

export function GenerateQuestionDialogHeader({
  children,
  onBack,
}: GenerateQuestionDialogHeaderProps) {
  return (
    <div
      className="pb-4 sticky top-0 z-50 bg-white generate-content-header"
      style={{ boxShadow: '0px -1px 0px 0px #E7EDF0 inset' }}
    >
      {onBack ? (
        <div className="back">
          <IconButton aria-label={translate('Back')} onClick={onBack}>
            <IconChevron direction="left" />
          </IconButton>
        </div>
      ) : null}
      <div className="title">
        <div className="flex">
          <Badge textTransform="capitalize" tone="ai">
            {translate('AI Assisted')}
            <LearnMoreIcon />
          </Badge>
        </div>
        <div className="font-display text-md leading-normal text-blue-900 font-700">
          {translate('Generate Questions')}
        </div>
        <div className="text-sans text-base leading-normal text-blue-600">
          {children}
        </div>
      </div>
    </div>
  );
}

export function GenerateQuestionDialogContent({
  children,
  header,
  footer,
}: GenerateQuestionDialogContentProps) {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex-none">{header}</div>
      <div className="flex-1 overflow-y-auto min-h-0">{children}</div>
      {footer ? <div className="flex-none">{footer}</div> : null}
    </div>
  );
}

GenerateQuestionDialogContent.Header = GenerateQuestionDialogHeader;
GenerateQuestionDialogContent.Footer = GenerateQuestionsDialogFooter;
